'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsEvent = exports.INTERCOM_EVENTS = undefined;

var _analyticsConstants = require('./analyticsConstants');

Object.defineProperty(exports, 'INTERCOM_EVENTS', {
  enumerable: true,
  get: function get() {
    return _analyticsConstants.INTERCOM_EVENTS;
  }
});

var _intercomService = require('./intercomService');

var analyticsEvent = exports.analyticsEvent = _intercomService.intercomTrackEvent;


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/index.js
// module id = 47
// module chunks = 0